






































































































































































































































import Vue from 'vue'
import { Learner } from 'vue/types/vue'
import { startCandidateContact } from '@/helpers'
import RemoveIcon from '@/assets/svgs/x_close_icon.svg?inline'
import LocationIcon from '@/assets/svgs/location_icon.svg?inline'
import ScheduleIcon from '@/assets/svgs/schedule_icon.svg?inline'
import DateIcon from '@/assets/svgs/date_icon.svg?inline'
import GoldBadge from '@/assets/svgs/gold_badge.svg?inline'
import SilverBadge from '@/assets/svgs/silver_badge.svg?inline'
import BronzeBadge from '@/assets/svgs/bronze_badge.svg?inline'
import Checkmark from '@/assets/svgs/checkmark.svg?inline'
import Button from '@/components/atoms/Button.vue'

interface Data {
  mockGoldSkillNames: string[]
  mockSilverSkillNames: string[]
  mockBronzeSkillNames: string[]
  mockNoBadgeSkills: string[]
  mockInProgressSkills: {name: string, percentCompletion: number}[]
}

interface Methods {
  handleCandidateContact: () => void
}

interface Computed {}

interface Props {
  learner: Learner
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'CandidateDrawer',
  data: () => ({
    // TO DO - update learner object from apollo server so it returns skill names
    mockGoldSkillNames: [
      'General Patient Care',
      'Testing & Lab Procedures',
      'Patient Care Coordination & Education',
      'Communication and Customer Service'
    ],
    mockSilverSkillNames: [
      'Career Success in Healthcare',
      'Anatomy & Physiology',
      'Infection Control',
      'Personal Care'
    ],
    mockBronzeSkillNames: [
      'Direct Supervision',
      'Medical Law and Ethics'
    ],
    mockNoBadgeSkills: [
      'Electronic Medical Records',
      'Communication'
    ],
    mockInProgressSkills: [
      { name: 'Infection Control', percentCompletion: 0 }
    ]
  }),
  props: {
    learner: Object
  },
  methods: {
    handleCandidateContact () {
      // TODO: Uncomment parameter when helper function is functional
      startCandidateContact(/* this.$props.learner.id */)
    }
  },
  components: {
    RemoveIcon,
    LocationIcon,
    ScheduleIcon,
    DateIcon,
    GoldBadge,
    SilverBadge,
    BronzeBadge,
    Checkmark,
    Button
  }
})
